import {call, put} from 'redux-saga/effects';
import {receiveFacilitiesMetaData} from "../actions/facilitiesMetaActions";
import {fetchFacilitiesMetaData} from "../api/fetchFacilitiesData";

export default function* getFacilitiesMetaData(action) {
  try {
    const facilitiesMetaData = yield call(fetchFacilitiesMetaData);
    yield put(receiveFacilitiesMetaData(facilitiesMetaData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/facilitiesMetaSaga.js